module.exports = __webpack_public_path__ + "img/26.f7d9163a.png";